import { SET_HIDING_RECOMMENDATION } from 'actionTypes';

export default function modalReducer(state = null, action) {
  switch (action.type) {
    case SET_HIDING_RECOMMENDATION:
      return action.uuid;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/hidingRecommendationReducer.js